import { call, put, takeEvery } from "redux-saga/effects"

import {
  ADD_NEW_BRAND,
  GET_BRANDS,
  UPDATE_BRAND,
  GET_BRAND_DETAIL,
} from "./actionTypes"

import {
  getBrandsSuccess,
  getBrandsFail,
  addNewBrandSuccess,
  addNewBrandFail,
  updateBrandSuccess,
  updateBrandFail,
  getBrandDetailSuccess,
  getBrandDetailFail,
} from "./actions"

import { getBrands, manageBrand } from "../../helpers/backend_helper"

function* fetchBrands({ payload: { options, history } }) {
  try {
    const response = yield call(getBrands, options)
    yield put(getBrandsSuccess(response))
  } catch (error) {
    yield put(getBrandsFail(error))
  }
}

function* fetchBrandDetail({ payload: { options, history } }) {
  try {
    const response = yield call(getBrands, options)
    yield put(getBrandDetailSuccess(response))
  } catch (error) {
    yield put(getBrandDetailFail(error))
  }
}

function* onAddNewBrand({ payload: { data, options, history } }) {
  try {
    const response = yield call(manageBrand, data, options)
    
    if (data.actionType === "create") {
      yield put(addNewBrandSuccess(response))
      const { brandID } = response
      history.push(`/brands/${brandID}`)
    } else if (data.actionType === "update") {
      yield put(updateBrandSuccess(response))
      // For update, we don't navigate - the form component will handle setting readonly
    }
  } catch (error) {
    if (data.actionType === "create") {
      yield put(addNewBrandFail(error))
    } else if (data.actionType === "update") {
      yield put(updateBrandFail(error))
    }
  }
}

// function* onUpdateBrand({ payload: { brand, history } }) {
//   try {
//     const response = yield call(updateBrand, brand)
//     yield put(updateBrandSuccess(response))
//   } catch (error) {
//     yield put(updateBrandFail(error))
//   }
// }

function* brandsSaga() {
  yield takeEvery(GET_BRANDS, fetchBrands)
  yield takeEvery(GET_BRAND_DETAIL, fetchBrandDetail)
  yield takeEvery(ADD_NEW_BRAND, onAddNewBrand)
  //   yield takeEvery(UPDATE_BRAND, onUpdateBrand)
}

export default brandsSaga
